<template>
  <v-container>
    <div class="page">
      <div class="title">Databases to support ExposomeX platform:</div>
      <div class="title-description">Users can download the databases using the following links:</div>
      <v-divider class="line"></v-divider>
      <div v-for="(item, index) in data" :key="index">
        <div class="item-context">
          <span class="item-word">
            <b>{{item.name}}</b>: {{item.description}}
          </span>
          <v-btn variant="tonal" color="info" class="mr-2" size="x-small" @click="download_gz(item)">Download</v-btn>
        </div>
        <v-divider class="line"></v-divider>
      </div>
    </div>
  </v-container>
</template>
<script>
import { getDownloadUrl } from '@/config'

export default {
  data() {
    return {
      data: [{
        name: 'DB_Exposure',
        router: 'DB_Exposure',
        extension: '.tsv.gz',
        description: 'environmental factors (single or mixture exposure)'
      },{
        name: 'DB_Protein',
        router: 'DB_Protein',
        extension: '.tsv.gz',
        description: 'proteins'
      },{
        name: 'DB_Metabolite',
        router: 'DB_Metabolite',
        extension: '.gz',
        description: 'metabolites'
      },{
        name: 'DB_Disease',
        router: 'DB_Disease',
        extension: '.tsv.gz',
        description: 'diseases'
      },{
        name: 'DB_Meta',
        router: 'DB_Meta',
        extension: '.tsv.gz',
        description: 'references for meta-analysis'
      },{
        name: 'DB_Exposure_Protein',
        router: 'DB_Exposure_Protein',
        extension: '.tsv.gz',
        description: 'relationship between exposure and protein'
      },{
        name: 'DB_Protein_Protein',
        router: 'DB_Protein_Protein',
        extension: '.tsv.gz',
        description: 'interactions between protein and protein'
      },{
        name: 'DB_Protein_Disease',
        router: 'DB_Protein_Disease',
        extension: '.tsv.gz',
        description: 'relationship between protein and disease'
      },{
        name: 'DB_Exposure_GO',
        router: 'DB_Exposure_GO',
        extension: '.tsv.gz',
        description: 'relationship between exposure and GO (i.e. phenotype)'
      },{
        name: 'DB_GO_Disease',
        router: 'DB_GO_Disease',
        extension: '.tsv.gz',
        description: 'relationship between exposure and disease'
      },{
        name: 'DB_HExpPredict',
        router: 'DB_HExpPredict',
        extension: '.xlsx',
        description: 'predict blood concentrations of chemicals and prioritize chemicals of health concern'
      },{
        name: 'DB_NTA_Chemical',
        router: 'DB_NTA_Chemical',
        extension: '.tsv.gz',
        description: 'non-targeted analysis for chemical annotation'
      },{
        name: 'DB_NTA_IonAdduct',
        router: 'DB_NTA_IonAdduct',
        extension: '.tsv.gz',
        description: 'non-targeted analysis for the mass-to-charge conversion of ion adduct'
      }]
    };
  },
  methods: {
    async download_gz(item){
      let a = document.createElement('a')
      a.href = getDownloadUrl('demoV100', `${item.router}${item.extension}`)
      a.target = '_blank'
      a.click()
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
.title {
  font-weight: 600;
  font-size: $webpage-large-font-size;
  margin: 1em 0 0.6em;
}
.title-description {
  margin-bottom: 0.6em;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.line {
  width: 90%;
}
.item-word {
  min-width: 800px;
}

@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .item-word {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}

@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 1em;
    align-items: center;
    justify-content: space-between;
  }
  .item-word {
    min-width: 0;
  }
}
</style>
